import Work1 from "../../assets/ERP SYSTEM DASHBOARD.webp";
import Work2 from "../../assets/CURRENCY CONVERTER.webp";
import Work3 from "../../assets/WEATHER.webp";
import Work4 from "../../assets/PORTFOLIO.webp";
import Work5 from "../../assets/blog-1.svg";
import Work6 from "../../assets/Food.webp"
import work7 from"../../assets/Chat-App.webp";
import work8 from "../../assets/Password.webp"

const Menu = [
	{
		id: 1,
		image: Work1,
		title: "College ERP System",
		category: ["Frontend","Backend","React"],
		repositoryUrl: "https://github.com/CoderSadhan/College-ERP-system"
	},
	{
		id: 2,
		image: Work2,
		title: "Currency Convertar",
		category: ["Frontend"],
		url: "https://currencyconverter-bysadhan.netlify.app/",
		repositoryUrl: "https://github.com/CoderSadhan/Currency_Converter"
	},
	
	
	{
		id: 3,
		image: Work3,
		title: "Weather App",
		category: ["Frontend"],
		url: "https://weatherforcast-bysadhan.netlify.app/",
		repositoryUrl: "https://github.com/CoderSadhan/Weather-App"
	},
	{
		id: 4,
		image: Work4,
		title: "Devfolio",
		category: ["Frontend", "React"],
		url: "https://sadhandas.netlify.app/",
		repositoryUrl: "https://github.com/CoderSadhan/My-Portfolio"
	},
	{
		id: 5,
		image: Work5,
		title: "Youtube Ad Skipper",
		category: ["Backend"],
		repositoryUrl: "https://github.com/CoderSadhan/Youtube-Ad-Skipper"
	},
	{
		id: 6,
		image: Work6,
		title: "Food Delivery App",
		category:["Frontend" , "Backend"],
		repositoryUrl : "https://github.com/CoderSadhan/Food-Delivery-App"
		
	},
	{
		id: 7,
		image: work7,
		title: "Online Chat Application",
		category:["Frontend" ],
		url : "https://online-chat-app-sadhan-das-projects.vercel.app/",
		repositoryUrl : "https://github.com/CoderSadhan/Online_Chat_App"
	},
	{
		id: 8,
		image: work8,
		title: "Random Password Generator",
		category:["Frontend" ],
		url:"https://random-password-generator-sadhan-das-projects.vercel.app/",
		repositoryUrl : "https://github.com/CoderSadhan/Random_Password_Generator"
	}
];

export default Menu;
